import core from '@/helpers/client'

const inventoryCategoryService = {
  async headInventoryCategoryAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories`,
      params
    )
    return result
  },
  async getInventoryCategoryListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories`,
      params
    )
    return result
  },
  async getInventoryCategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/treenode`,
      params
    )
    return result
  },
  async getMappingInventoryCategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/mappingtreenode`,
      params
    )
    return result
  },
  async getInventoryCategoryDetailAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/${id}`,
      params
    )
    return result
  },
  async getInventoryCategoryByIdsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/manysearch`,
      params
    )
    return result
  },
  async getInventoryProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/${id}/skus`
    )
    return result
  },
  async createInventoryCategoryAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories`,
      model
    )
    return result
  },
  async updateInventoryCategoryAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/${id}`,
      model
    )
    return result
  },
  async updateAllInventoryCategoryApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/${id}/approval`,
      model
    )
    return result
  },
  async deleteInventoryCategoryByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/InventoryCategories/delete/${id}`
    )
    return result
  },
}
export default inventoryCategoryService
